import { useMemo } from "react";
import ThemeProviderProps from "./ThemeProviderProps";
import { useSelector } from "react-redux";
import { selectOrganisationTheme } from "@selectors/organisationSelector";
import { selectOrganisationContextId } from "@selectors/appSelector";


const ThemeProvider = (props: ThemeProviderProps) => {
    const organisationId = useSelector(selectOrganisationContextId);
    const theme = useSelector(selectOrganisationTheme(organisationId));

    const colors = useMemo(
        () => {
            if (!theme) return undefined;
            return {
                '--text-color': theme.text_color,
                '--primary-color': theme.primary_color,
                '--secondary-color': theme.secondary_color,
                '--question-color': theme.question_color,
                '--question-text': theme.question_text_color,
                '--answer-text': theme.answer_text_color,
                '--gray-color': theme.gray_color,
                '--border-color': theme.border_color,
                '--primary-button-text--color': theme.answer_color,
                '--secondary-button-text-color': theme.background_color,
                // Filled outline states use the organisation's existing primary button colour pair.
                '--secondary-button-hover-background-color': theme.primary_color,
                '--secondary-button-hover-text-color': theme.answer_color,
                '--chat-list-item-color': theme.topbar_color,
            } as React.CSSProperties;
        },
        [
            theme
        ],
    );

    return (<div style={colors}>
        {props.children}
    </div>);

}

export default ThemeProvider;
